import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
// import { ReactComponent as NewTabIcon } from '../../../assets/icons/tables/new-tab.svg';
// import { appCurrentBranding } from '../../../config/branding';
import DefaultApiLimit from '../../../config/defaultLimit';
import {
  AccountsInterFace,
  RequestAccountInterface,
} from '../../../interface/account-management.interface';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { setNotificationMessage } from '../../../redux/slices/NotificationManagementSlice';
import { disableUsersFilterApplied } from '../../../redux/slices/UsersManagementSlice';
import {
  fetchAllAccounts,
  fetchUtilityProviderFilters,
  setSortData,
  updateUtilityProviderFilters,
} from '../../../redux/slices/UtilityProviderManagementSlice';
import MyButton from '../../../shared-components/button/Button';
import CustomTable from '../../../shared-components/custom-table/CustomTable';
import ConfirmBox from '../../../shared-components/modal-box/ConfirmBox';
import ModalBox from '../../../shared-components/modal-box/ModalBox';
import SuccessNotification from '../../../shared-components/success-notification/SuccessNotification';
import UtilityDetailsSidePanel from '../../../shared-components/table-side-panel/UtilityDetailsSidePanel';
import { GetParametersFromCommonFilters } from '../../../shared-functions/CommonFilters';
import ConvertUTCtoDate from '../../../shared-functions/ConvertUTCtoDate';
import { exportCSV, exportPDF } from '../../../shared-functions/ExportFile';
import { permissionCheck } from '../../../shared-functions/JWTDocodeFunction';
// import authApi from '../../../utils/api/auth';
import accountApi from '../../../utils/api/utility-provider';

import AddUtilityAccount from './add-utility-account';

interface ModalInterface {
  title: string;
  header: boolean;
  content: JSX.Element;
  rightCorner: string;
  notification: boolean;
}

/**
 * Facility account list
 * @param param0
 * @returns
 */
function UtilityProviderList() {
  const { t } = useTranslation('account');
  const dispatch = useAppDispatch();
  const {
    accounts,
    limit,
    page,
    totalPages,
    totalResults,
    loading,
    filterListLoading,
    filters,
    isFilterUpdated,
    sortBy,
    sortField,
  } = useAppSelector((state) => state.utility);

  const [openStatus, setOpenStatus] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [exportLoader, setExportLoader] = useState<boolean>(false);
  const [sidePanelOpen, setSidePanelOpen] = useState<boolean>(false);
  const [searchParameters, setSearchParameters] = useSearchParams();
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [modalView, setModalView] = useState<ModalInterface>({
    title: '',
    header: false,
    content: <div />,
    rightCorner: '',
    notification: false,
  });

  /**
   * Fetch the account details in redus
   */
  const fetchData = (data: RequestAccountInterface) => {
    if (!loading) {
      dispatch(fetchAllAccounts(data));
    }
  };
  /**
   * Modal box close function
   */
  const closeModal = (message: string) => {
    if (message) {
      setOpenStatus(true);
      setModalView({
        title: '',
        header: false,
        content: (
          <SuccessNotification
            title={message}
            description=""
            notificationCloseTimer={3000}
            onNotificationClose={() => {
              setOpenStatus(false);
            }}
          />
        ),
        rightCorner: '',
        notification: true,
      });
    } else {
      setOpenConfirm(false);
      setOpenStatus(false);
    }
  };

  /**
   * Add account function
   */
  const addAccount = () => {
    // setIsEditMode(false);
    setSidePanelOpen(true);
  };

  /**
   * Table pagination function
   * @param value
   */
  const pageAndLimitChange = (value: RequestAccountInterface) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    fetchData({ ...queryParameters, ...value, sortField, sortBy });
  };

  // /**
  //  * handleAvailabilityChange
  //  */
  // const handleAvailabilityChange = (name: string, value: string) => {
  //   setCurrentPage(value);
  // };

  /**
   * view facility function
   * @param currentData
   */
  // const viewUtilityFunction = (currentData: any) => {
  //   const accountDetails = accounts.find((value: AccountsInterFace) => value.id === currentData);
  //   if (accountDetails && Object.keys(accountDetails).length > 0) {
  //     const request: AccessUtilityPortal = {
  //       _id: accountDetails._id,
  //     };

  //     authApi
  //       .accessUtilityPortal(request)
  //       .then((response) => {
  //         const responseData = response?.data;
  //         const deployedType = window.origin.includes('test');

  //         window.open(
  //           `https://${appCurrentBranding}-utility${deployedType ? '-test' : ''}.web.app/login?accessToken=${responseData.access.token}&accessTokenExpires=${responseData.access.expires}&refreshToken=${responseData.refresh.token}&refreshTokenExpires=${responseData.refresh.expires}}`,
  //           '_blank',
  //         );
  //       })
  //       .catch((error) => {
  //         dispatch(
  //           setNotificationMessage({
  //             message: error?.response?.data?.message,
  //             status: true,
  //             type: error,
  //             code: error?.response?.data?.code,
  //           }),
  //         );
  //       });
  //   }
  // };

  const column = [
    {
      label: t('date'),
      accessorKey: 'createdAt' as keyof AccountsInterFace,
      sortAllow: true,
    },
    {
      label: t('userName'),
      accessorKey: 'name' as keyof AccountsInterFace,
      sortAllow: true,
      /**
       * No of stations
       */
      customData: (currentRow: AccountsInterFace) => (
        <p className="hyper-link-coloum">{currentRow.name || '-'}</p>
      ),
    },
    {
      label: t('emailId'),
      accessorKey: 'email' as keyof AccountsInterFace,
      sortAllow: false,
    },
    {
      label: t('address'),
      accessorKey: 'address' as keyof AccountsInterFace,
      sortAllow: true,
    },
  ];

  /**
   * Handle the filter data clear function
   */
  const handleSortFunction = (sortData: any) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    dispatch(setSortData(sortData));
    fetchData({
      ...queryParameters,
      sortBy: sortData.sortBy,
      sortField: sortData.sortField,
      page: DefaultApiLimit.page,
      limit,
    });
  };

  /**
   * Column defination for the table
   */
  const currentColumns = [
    { label: t('sNo'), accessorKey: '__serial__' },
    { label: t('date'), accessorKey: 'createdAt' },
    { label: t('userName'), accessorKey: 'name' },
    { label: t('emailId'), accessorKey: 'email' },
    { label: t('address'), accessorKey: 'address' },
  ];

  /**
   * Filtering columns for export without hidden columns
   */
  const exportCurrentColumns = currentColumns.filter(
    (col) => col.accessorKey === '__serial__' || !hiddenColumns.includes(col.accessorKey),
  );

  /**
   * Export data function (hardcoded headers & fields)
   */
  const exportDataPdfOrCSV = (type: string) => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    setExportLoader(true);
    const payload = {
      ...queryParameters,
    };
    if (sortBy) payload.sortBy = sortBy;
    if (sortField) payload.sortField = sortField;
    accountApi
      .exportData(payload)
      .then((response) => {
        const headers = exportCurrentColumns.map((col) => col.label);

        // const rows = response.data.map((row: AccountsInterFace, index: number) => [
        //   index + 1,
        //   ConvertUTCtoDate(row?.createdAt || ''),
        //   row.name,
        //   row.email,
        //   row.address,
        //   'Utility Owner', // or dynamically use row.accountType if available
        // ]);
        const rows = response.data.map((row: AccountsInterFace, index: number) =>
          exportCurrentColumns.map((col) => {
            switch (col.accessorKey) {
              case '__serial__':
                return index + 1;

              case 'createdAt':
                return row?.createdAt ? ConvertUTCtoDate(row.createdAt) : t('notAvailable');

              case 'name':
                return row.name || t('notAvailable');

              case 'email':
                return row.email || t('notAvailable');

              case 'address':
                return row.address || t('notAvailable');

              default:
                return (row as any)[col.accessorKey] || t('notAvailable');
            }
          }),
        );
        setExportLoader(false);
        if (rows.length > 0) {
          if (type === 'csv') {
            exportCSV(headers, rows, 'account-list.csv');
          } else {
            exportPDF(headers, rows, 'account-list.pdf');
          }
        }
      })
      .catch((error) => {
        setExportLoader(false);
        dispatch(
          setNotificationMessage({
            message: error?.response?.data?.message,
            status: true,
            type: 'error',
            code: error?.response?.data?.code,
          }),
        );
      });
  };

  /**
   * Function to refresh data
   */
  const handleRefresh = () => {
    const queryParameters = GetParametersFromCommonFilters(filters);
    fetchData({ ...queryParameters, page, limit, sortField, sortBy });
  };

  /**
   * Function to open side panel on row click
   */
  const handleOpenSidePanelOnRowClick = (utilityId: string) => {
    // Set or update the logId param
    searchParameters.set('utilityId', utilityId);
    // Apply the updated search params to the URL
    setSearchParameters(searchParameters);
  };

  useEffect(() => {
    if (isFilterUpdated || accounts.length === 0) {
      const queryParameters = GetParametersFromCommonFilters(filters);
      dispatch(
        fetchAllAccounts({
          page: DefaultApiLimit.page,
          limit,
          ...queryParameters,
        }),
      );
      dispatch(disableUsersFilterApplied());
    }
  }, [filters]);

  return (
    <div>
      <ModalBox
        open={openStatus}
        title={modalView.title}
        content={modalView.content}
        closeModal={() => setOpenStatus(false)}
        header={modalView.header}
        rightCorner={modalView.rightCorner}
        notification={modalView.notification}
      />
      <ConfirmBox
        open={openConfirm}
        title={t('deleteUtilityConfirmTitle')}
        subTitle={t('deleteUtilityConfirmSubtitle')}
        // conformSubmit={deleteConfirmFunction}
        closeModal={() => {
          setOpenConfirm(false);
        }}
      />
      <CustomTable
        header={column}
        data={accounts}
        version="v2"
        limit={limit}
        page={page}
        sortData={{ sortBy, sortField }}
        handleSortChange={handleSortFunction}
        totalPages={totalPages}
        totalResults={totalResults}
        loading={loading}
        serialNo
        pageLimitChange={pageAndLimitChange}
        onHiddenColumnsChange={setHiddenColumns}
        actionButton
        height={window.innerHeight >= 700 ? 315 : 287}
        filters={filters}
        filtersToDispatch={updateUtilityProviderFilters}
        filterListLoading={filterListLoading}
        filterListToDispatch={fetchUtilityProviderFilters}
        sizeChangeButtonRequired
        actionDropdown
        exportData={accounts}
        exportLoader={exportLoader}
        exportDataPdfOrCSV={(permissionCheck('utility_export') as any) && exportDataPdfOrCSV}
        rightTopContent={
          <div className="table-bottom-button-list">
            {permissionCheck('utility_provider_add') && (
              <div className="table-button-item">
                <MyButton
                  label={t('addAccount')}
                  buttonType="submit"
                  onClickFunc={addAccount}
                  svgIcon={<Plus />}
                />
              </div>
            )}
          </div>
        }
        sidePanelTopLeftContent={
          <div className="side-panel-header-left-icons">
            {/* {!isEditMode &&  !sidePanelOpen &&(
              <div
                role='presentation'
                className='access-facility'
                onClick={() => viewUtilityFunction(searchParameters.get('utilityId'))}
              >
                <NewTabIcon />
              </div>
            )} */}
          </div>
        }
        refreshRequired
        handleRefresh={handleRefresh}
        ReferenceCurrentPages={handleRefresh}
        hoverLabel={t('refresh')}
        rowClickEvent={handleOpenSidePanelOnRowClick}
        rowClickParamsKey="utilityId"
        sidePanelEnabled={sidePanelOpen}
        sidePanelManualContent={
          <AddUtilityAccount
            closeModal={closeModal}
            sidebarClosed={() => setSidePanelOpen(false)}
          />
        }
        onSidePanelClose={() => setSidePanelOpen(false)}
        rowClickSidePanel={<UtilityDetailsSidePanel fetchIdFrom="queryParams" />}
      />
    </div>
  );
}

export default UtilityProviderList;
